export default {
  data() {
    return {
      dialogImageUrl: null,
      previewImageDialog: false
    }
  },
  methods: {
    previewImage(url) {
      this.dialogImageUrl = url
      this.previewImageDialog = true
    }
  }
}
